import { EmployeeWorkLetterType } from 'src/api';
import type { SelectFieldOption } from 'src/types/components';

export const FormFields = {
  company: 'company',
  letterType: 'letterType',
} as const;
export type FormFields = (typeof FormFields)[keyof typeof FormFields];

export const workLetterTypeSelectOptions: SelectFieldOption<EmployeeWorkLetterType>[] = [
  { value: EmployeeWorkLetterType.Employment, label: 'Employment Letter' },
  {
    value: EmployeeWorkLetterType.EmploymentWithIncomeInfo,
    label: 'Employment Letter with Income Info',
  },
  { value: EmployeeWorkLetterType.Immigration, label: 'Immigration Letter' },
];
